module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-5.60f57ce0.jpg";